import { BlogData, BlogPostFM, ContentType } from '@bm-js/atlascloud-shared'
import { LinkComponentType } from './CLink'
import { BlogPost } from './BlogPost'

type Props = {
  /**
   * Should be maximum 4 posts
   */
  slicedPosts: BlogPostFM[] | null
  blogName: string | null
  content?: ContentType<BlogData>
  hideHeader?: boolean
  LinkComponent: LinkComponentType
}

export const BlogContent = ({
  slicedPosts,
  blogName,
  content,
  hideHeader,
  LinkComponent,
}: Props) => {
  if (!slicedPosts?.length) return null

  return (
    <div
      style={{
        marginBottom: content?.data.marginBottom,
      }}
    >
      {!hideHeader && (
        <div className='flex justify-between items-end mb-2'>
          <>
            <h2 className='text-3xl text-customerPrimary-400'>{blogName}</h2>
            <LinkComponent
              href='/nyheter'
              className='text-customerPrimary-400 font-semibold text-sm underline'
            >
              Läs alla nyheter
            </LinkComponent>
          </>
        </div>
      )}
      <div className='grid @3xl/grid:grid-cols-2 grid-cols-1 gap-2 @3xl/grid:grid-rows-3'>
        {slicedPosts.map((post, i) => (
          <BlogPost
            LinkComponent={LinkComponent}
            i={i}
            key={post._id}
            post={post}
          />
        ))}
      </div>
    </div>
  )
}
